import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حساب البروتين: أحسب إحتياج جسمك اليومي من البروتين";
const DESCRIPTION =
  "استخدم حاسبة البروتين لتقدير الكمية المحددة لتناول البروتين يوميًا (جرام / يوم) لفقدان الوزن واكتساب قوة العضلات.";
const KEYWORDS =
  "حساب البروتين، حاسبة البروتين، إحتياج البروتين اليومي، تناول البروتين لفقدان الوزن، بناء العضلات، تحسين القوة العضلية";
const OG_URL = "https://do-calculate.com/calculator/ar/protein/";
const data1 = [
  { ageGroup: "1 -> 3", proteinNeeded: 13 },
  { ageGroup: "4 -> 8", proteinNeeded: 19 },
  { ageGroup: "9 -> 13", proteinNeeded: 34 },
  { ageGroup: "14 -> 18 (فتيات)", proteinNeeded: 46 },
  { ageGroup: "14 -> 18 (فتيان)", proteinNeeded: 52 },
  { ageGroup: "19 -> 70+ (نساء)", proteinNeeded: 46 },
  { ageGroup: "19 -> 70+ (رجال)", proteinNeeded: 56 },
];
const data2 = [
  {
    category: "الثلث الأول من الحمل",
    safeIntake: 1,
    additionalEnergyRequirement: "375 kJ/day",
    proteinEnergyRatio: 0.04,
  },
  {
    category: "الثلث الثاني من الحمل",
    safeIntake: 10,
    additionalEnergyRequirement: "1,200 kJ/day",
    proteinEnergyRatio: 0.11,
  },
  {
    category: "الثلث الأخير من الحمل",
    safeIntake: 31,
    additionalEnergyRequirement: "1,950 kJ/day",
    proteinEnergyRatio: 0.23,
  },
  {
    category: "أول 6 اشهر من الرضاعة",
    safeIntake: 19,
    additionalEnergyRequirement: "2,800 kJ/day",
    proteinEnergyRatio: 0.11,
  },
  {
    category: "الرضاعة بعد أول 6 اشهر",
    safeIntake: 13,
    additionalEnergyRequirement: "1,925 kJ/day",
    proteinEnergyRatio: 0.11,
  },
];
const data3 = [
  { food: "حليب (1 cup/8 oz)", proteinAmount: "8 g" },
  { food: "بيض (1 large/50 g)", proteinAmount: "6 g" },
  { food: "لحم (1 slice / 2 oz)", proteinAmount: "14 g" },
  { food: "الطعام البحري (2 oz)", proteinAmount: "16 g" },
  { food: "الخبز (1 slice/64 g)", proteinAmount: "8 g" },
  { food: "حبوب ذرة (1 cup/166 g)", proteinAmount: "16 g" },
  { food: "الرز (1 cup/195 g)", proteinAmount: "5 g" },
  { food: "الفاصوليا الجافة (1 cup/92 g)", proteinAmount: "16 g" },
  { food: "المكسرات (1 cup/92 g)", proteinAmount: "20 g" },
  { food: "الفواكه والخضراوات (1 cup)", proteinAmount: "0-1 g" },
  { food: "البيتزا (1 slice/107 g)", proteinAmount: "12 g" },
];
function ProteinCalculator() {
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("male");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [activity, setActivity] = useState("sedentary");
  const [resultADA, setResultADA] = useState(null);
  const [resultCDC, setResultCDC] = useState(null);
  const [resultWHO, setResultWHO] = useState(null);
  const [ageError, setAgeError] = useState("");
  const [heightError, setHeightError] = useState("");
  const [weightError, setWeightError] = useState("");
  const handleAgeChange = (event) => {
    const inputAge = event.target.value;
    if (inputAge !== "") {
      const parsedAge = parseInt(inputAge, 10);
      if (!isNaN(parsedAge) && parsedAge >= 18 && parsedAge <= 85) {
        setAge(inputAge);
        setAgeError("");
      } else {
        setAge("");
        if (isNaN(parsedAge)) {
          setAgeError("تأكد من ادخال عدد");
        } else if (parsedAge < 18) {
          setAge(inputAge);
          setAgeError("العمر بين 18 - 85");
        } else if (parsedAge > 85) {
          setAge(inputAge);
          setAgeError("العمر بين 18 - 85");
        }
      }
    } else {
      setAge("");
      setAgeError("");
    }
  };
  const handleHeightChange = (event) => {
    const inputHeight = event.target.value;
    if (inputHeight !== "") {
      if (!isNaN(inputHeight)) {
        setHeight(inputHeight);
        setHeightError("");
      } else {
        setHeight("");
        if (isNaN(inputHeight)) {
          setHeightError("تأكد من ادخال عدد");
        }
      }
    } else {
      setHeight("");
      setHeightError("");
    }
  };
  const handleWeightChange = (event) => {
    const inputWeight = event.target.value;
    if (inputWeight !== "") {
      if (!isNaN(inputWeight)) {
        setWeight(inputWeight);
        setWeightError("");
      } else {
        setWeight("");
        if (isNaN(inputWeight)) {
          setWeightError("تأكد من ادخال عدد");
        }
      }
    } else {
      setWeight("");
      setWeightError("");
    }
  };
  const calculateProtein = () => {
    const proteinIntakeADA = calculateProteinIntakeADA(
      age,
      gender,
      weight,
      activity,
      height
    );
    const proteinIntakeCDC = calculateProteinIntakeCDC(
      age,
      gender,
      weight,
      activity,
      height
    );
    const proteinIntakeWHO = calculateProteinIntakeWHO(
      age,
      gender,
      weight,
      activity,
      height
    );
    return {
      proteinIntakeADA: proteinIntakeADA,
      proteinIntakeCDC: proteinIntakeCDC,
      proteinIntakeWHO: proteinIntakeWHO,
    };
  };
  const calculateProteinIntakeADA = (age, gender, weight, activity) => {
    let proteinIntakeMin = 0;
    let proteinIntakeMax = 0;
    if (age >= 18 && age <= 80) {
      if (gender === "male" || gender === "female") {
        if (activity === "sedentary") {
          proteinIntakeMin = weight * 0.8;
          proteinIntakeMax = weight * 1.0;
        } else {
          proteinIntakeMin = weight * 1.0;
          proteinIntakeMax = weight * 1.8;
        }
      }
    }
    return `${Math.round(proteinIntakeMin)} - ${Math.round(proteinIntakeMax)}`;
  };
  const calculateProteinIntakeCDC = (age, gender, weight, activity, height) => {
    let bmr = 0;
    if (gender === "male") {
      bmr = 10 * weight + 6.25 * height - 5 * age + 5;
    } else if (gender === "female") {
      bmr = 10 * weight + 6.25 * height - 5 * age - 161;
    }
    let activityFactor = 1.0;
    switch (activity) {
      case "sedentary":
        activityFactor = 1.15;
        break;
      case "light":
        activityFactor = 1.325;
        break;
      case "moderate":
        activityFactor = 1.42;
        break;
      case "active":
        activityFactor = 1.52;
        break;
      case "veryActive":
        activityFactor = 1.67;
        break;
      case "extraActive":
        activityFactor = 1.85;
        break;
      default:
        activityFactor = 1.0;
        break;
    }
    const proteinIntakeMin = (0.1 * bmr * activityFactor) / 4;
    const proteinIntakeMax = (0.35 * bmr * activityFactor) / 4;
    return `${Math.round(proteinIntakeMin)} - ${Math.round(proteinIntakeMax)}`;
  };
  const calculateProteinIntakeWHO = (age, gender, weight, activity, height) => {
    let proteinIntake = 0;
    if (age >= 18 && age <= 80) {
      if (gender === "male" || gender === "female") {
        proteinIntake = weight * 0.83;
      }
    }
    return Math.round(proteinIntake);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const result = calculateProtein();
    setResultADA(result.proteinIntakeADA);
    setResultCDC(result.proteinIntakeCDC);
    setResultWHO(result.proteinIntakeWHO);
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم حاسبة البروتين بتقدير الكمية اليومية من البروتين الغذائي
                  التي يحتاجها البالغون للبقاء في صحة جيدة.
                  <br /> عادةً ما يحتاج الأطفال، وأولئك الذين ينشطون بدنيًا
                  للغاية، والنساء الحوامل والمرضعات إلى المزيد من البروتين.
                  <br />
                  تعتبر الآلة الحاسبة مفيدة أيضًا لمراقبة تناول البروتين لأولئك
                  الذين يعانون من أمراض الكلى أو أمراض الكبد أو مرض السكري أو
                  الحالات الأخرى التي يكون فيها تناول البروتين عاملاً.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة البروتين في الجسم
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmit}>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <input
                      placeholder="140"
                      value={height}
                      onChange={handleHeightChange}
                      required
                      className="form-control"
                      style={{ width: "130px", marginLeft: "10px" }}
                    />
                    <span>سم</span>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <input
                      placeholder="65"
                      value={weight}
                      onChange={handleWeightChange}
                      required
                      className="form-control"
                      style={{ width: "130px", marginLeft: "10px" }}
                    />
                    <span>كغ</span>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <input
                      placeholder="18"
                      value={age}
                      onChange={handleAgeChange}
                      required
                      className="form-control"
                      style={{ width: "130px", marginLeft: "10px" }}
                    />
                    <span>18 - 85</span>
                  </div>

                  <div className="form-group d-flex align-items-center">
                    <b><label >الجنس</label></b>
                    <div style={{ marginRight: "40px" }}>
                      <label style={{ marginLeft: "15px" }}>
                        <input
                          type="radio"
                          value="male"
                          checked={gender === "male"}
                          onChange={(e) => setGender(e.target.value)}
                        />
                        {" "}ذكر
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="female"
                          checked={gender === "female"}
                          onChange={(e) => setGender(e.target.value)}
                        />
                        {" "}أنثى
                      </label>
                    </div>
                  </div>

                  <br />

                  <div>
                    <b><label className="form-label ms-2">معدل النشاط</label></b>
                    <br />
                    <select
                      value={activity}
                      onChange={(e) => setActivity(e.target.value)}
                      className="form-control"
                      style={{ width: "100%", fontSize: "14px" }}
                    >
                      <option value="sedentary">قليل النشاط: نشاط بدني ضئيل جدًا أو عدم ممارسة التمارين الرياضية</option>
                      <option value="light">متوسط النشاط: تمارين رياضية خفيفة لمدة 1-3 أيام في الأسبوع</option>
                      <option value="moderate">نشاط معتدل: تمارين رياضية معتدلة لمدة 4-5 أيام في الأسبوع</option>
                      <option value="active">نشاط مرتفع: ممارسة التمارين الرياضية يوميًا 3-4 مرات في الأسبوع</option>
                      <option value="veryActive">نشاط مكثف: ممارسة التمارين الرياضية المكثفة 6-7 مرات في الأسبوع</option>
                      <option value="extraActive">الرياضيين : تمرين مكثف للغاية يوميًا</option>
                    </select>
                  </div>

                  <br />
                  <hr />

                  <div className="mb-3">
                    <button type="submit" className="btn btn-success" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}>
                      احسب
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}
                      onClick={() => {
                        setAge("");
                        setActivity("sedentary");
                        setGender("male");
                        setHeight("");
                        setWeight("");
                        setResultADA(null);
                        setResultCDC(null);
                        setResultWHO(null);
                        setAgeError("");
                        setHeightError("");
                        setWeightError("");
                      }}
                    >
                      امسح النتيجة
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-12 col-md-6 ">
                {resultADA &&
                  resultCDC &&
                  resultWHO &&
                  resultADA !== "0" &&
                  resultCDC !== "0" &&
                  resultWHO !== "0" ? (
                  <div>
                    <p style={{ fontWeight: "bold" }}>
                      بناءً على المعلومات المعطاة، فيما يلي التوصيات الأساسية
                      بشأن تناول البروتين من عدة مؤسسات موثوقة:
                    </p>
                    <p>
                      جمعية الحمية الأمريكية (ADA):{" "}
                      <span
                        style={{
                          color: "rgb(25,135,84)",
                          fontWeight: "bold",
                        }}
                      >
                        {resultADA} غرام في اليوم
                      </span>
                    </p>
                    <p>
                      مراكز السيطرة على الأمراض والوقاية منها (CDC):{" "}
                      <span
                        style={{
                          color: "rgb(25,135,84)",
                          fontWeight: "bold",
                        }}
                      >
                        {resultCDC} غرام في اليوم
                      </span>
                    </p>
                    <p>
                      الحد الأدنى الآمن حسب منظمة الصحة العالمية:{" "}
                      <span
                        style={{
                          color: "rgb(25,135,84)",
                          fontWeight: "bold",
                        }}
                      >
                        {resultWHO} غرام في اليوم{" "}
                      </span>
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كل ما تحتاج لمعرفته حول البروتين: كيفية حسابه وأهميته في نظامك
                الغذائي
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>ماهو البروتين ؟</h2>
                </u>
                <br />
                <p>
                  البروتينات هي واحدة من ثلاثة مغذيات أساسية توفر الطاقة لجسم
                  الإنسان، إلى جانب الدهون والكربوهيدرات. كما أن البروتينات
                  مسؤولة أيضًا عن جزء كبير من العمل الذي يتم في الخلايا، فهي
                  ضرورية للبنية والوظيفة السليمة للأنسجة والأعضاء، وتعمل أيضًا
                  على تنظيمها. وهي تتألف من عدد من الأحماض الأمينية التي تعتبر
                  ضرورية لوظيفة الجسم المناسبة، وتعمل بمثابة اللبنات الأساسية
                  لأنسجة الجسم. <br /> هناك 20 حمضًا أمينيًا مختلفًا في المجمل،
                  ويحدد تسلسل الأحماض الأمينية بنية البروتين ووظيفته. في حين
                  يمكن تصنيع بعض الأحماض الأمينية في الجسم، هناك 9 أحماض أمينية
                  لا يمكن للإنسان الحصول عليها إلا من المصادر الغذائية (قد تؤدي
                  الكميات غير الكافية منها في بعض الأحيان إلى الوفاة)، وتسمى
                  الأحماض الأمينية الأساسية. تسمى الأطعمة التي توفر جميع الأحماض
                  الأمينية الأساسية بمصادر البروتين الكاملة، وتشمل كلاً من
                  المصادر الحيوانية (اللحوم ومنتجات الألبان والبيض والأسماك)
                  بالإضافة إلى المصادر النباتية (فول الصويا والكينوا والحنطة
                  السوداء).
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    يمكن تصنيف البروتينات على أساس الوظيفة التي تقدمها للجسم.
                    فيما يلي قائمة ببعض أنواع البروتينات :
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  الأجسام المضادة : البروتينات التي تحمي الجسم من الجزيئات
                  الغريبة، مثل الفيروسات والبكتيريا، عن طريق الارتباط بها .
                  <br />
                  الإنزيم : البروتينات التي تساعد على تكوين جزيئات جديدة وكذلك
                  إجراء العديد من التفاعلات الكيميائية التي تحدث في جميع أنحاء
                  الجسم. <br /> المرسال : البروتينات التي تنقل الإشارات في جميع
                  أنحاء الجسم للحفاظ على عمليات الجسم <br />
                  المكون الهيكلي : البروتينات التي تعمل كوحدات بناء للخلايا التي
                  تسمح للجسم في النهاية بالتحرك النقل/التخزين. <br /> البروتينات
                  هي التي تحرك الجزيئات في جميع أنحاء الجسم كما هو واضح، تلعب
                  البروتينات العديد من الأدوار المهمة في جميع أنحاء الجسم،
                  وبالتالي، من المهم توفير التغذية الكافية للجسم للحفاظ على
                  مستويات البروتين الصحية.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    كمية البروتين التي يحتاجها الفرد :
                  </h2>
                </u>
                <br />
                <p>
                  تعتمد كمية البروتين التي يحتاجها جسم الإنسان يوميًا على العديد
                  من الظروف، بما في ذلك إجمالي استهلاك الطاقة ونمو الفرد ومستوى
                  النشاط البدني. غالبًا ما يتم تقديره بناءً على وزن الجسم، كنسبة
                  مئوية من إجمالي السعرات الحرارية (10-35٪)، أو على أساس العمر
                  وحده. <br /> 0.8 جرام/كجم من وزن الجسم هو الحد الغذائي الموصى
                  به بشكل شائع . هذه القيمة هي الحد الأدنى الموصى به للحفاظ على
                  المتطلبات الغذائية الأساسية، ولكن استهلاك المزيد من البروتين،
                  حتى نقطة معينة، قد يكون مفيدًا، اعتمادًا على مصادر البروتين.
                  يتراوح نطاق تناول البروتين الموصى به بين 0.8 جم/كجم و1.8
                  جم/كجم من وزن الجسم، ويعتمد ذلك على العوامل العديدة المذكورة
                  أعلاه. يجب على الأشخاص النشطين للغاية، أو الذين يرغبون في بناء
                  المزيد من العضلات، أن يستهلكوا المزيد من البروتين بشكل عام.
                  تشير بعض المصادر إلى استهلاك ما بين 1.8 إلى 2 جم/كجم للأشخاص
                  النشطين للغاية. إن كمية البروتين التي يجب أن يستهلكها الشخص،
                  حتى الآن، ليست علمًا دقيقًا، ويجب على كل فرد استشارة أخصائي،
                  سواء كان اختصاصي تغذية أو طبيبًا أو مدربًا شخصيًا، للمساعدة في
                  تحديد احتياجاته الفردية.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    الأطعمة التي تحتوي على نسبة عالية من البروتين :
                  </h2>
                </u>
                <br />
                <p>
                  هناك العديد من المجموعات المختلفة من الطعام التي يمكن لأي شخص
                  تناولها لتلبية متطلباته من البروتين. بالنسبة للعديد من
                  الأشخاص، يأتي جزء كبير من البروتين من تناول اللحوم ومنتجات
                  الألبان، على الرغم من أنه من الممكن الحصول على ما يكفي من
                  البروتين مع تلبية بعض القيود الغذائية التي قد تكون لديكم. بشكل
                  عام، من الأسهل تلبية الكمية الموصى بها من البروتين عن طريق
                  استهلاك اللحوم ومنتجات الألبان، ولكن الإفراط في أي منهما يمكن
                  أن يكون له تأثير سلبي على الصحة. هناك الكثير من خيارات
                  البروتين النباتي، لكنها تحتوي بشكل عام على كمية أقل من
                  البروتين في وجبة معينة. من الناحية المثالية، يجب على الشخص أن
                  يستهلك مزيجًا من اللحوم ومنتجات الألبان والأطعمة النباتية من
                  أجل تلبية احتياجاته الغذائية اليومية والحصول على نظام غذائي
                  متوازن مليء بالعناصر الغذائية. <br />
                  أمثلة اللحوم/الألبان : بيض ، صدر دجاج ، جبن ، لبن ، لحم بقر ،
                  تونة ، صدور الديك الرومي ، سمكة جمبري . <br />
                  أمثلة نباتية : الحنطة السوداء ، الحمص ، منتجات الصويا ، زبدة
                  الفول السوداني على الخبز المحمص أو أي خبز آخر ، الفاصوليا
                  ،الأرز ، بذور القنب . <br />
                  بشكل عام، تعتبر اللحوم والدواجن والأسماك والبيض ومنتجات
                  الألبان مصادر بروتينية كاملة. المكسرات والبذور والبقوليات
                  والحبوب والخضروات، من بين أشياء أخرى، عادة ما تكون بروتينات
                  غير مكتملة. ومع ذلك، لا حرج في البروتينات غير الكاملة، وهناك
                  العديد من الأطعمة الصحية الغنية بالبروتين والتي تعتبر بروتينات
                  غير كاملة. طالما أنك تستهلك مجموعة كافية من البروتينات غير
                  الكاملة للحصول على جميع الأحماض الأمينية المطلوبة، فليس من
                  الضروري تناول الأطعمة البروتينية الكاملة على وجه التحديد. في
                  الواقع، بعض اللحوم الحمراء الغنية بالدهون، على سبيل المثال،
                  وهي مصدر شائع للبروتينات الكاملة، يمكن أن تكون غير صحية.
                  <br /> فيما يلي بعض الأمثلة على الأطعمة الغنية بالبروتين والتي
                  ليست بروتينات كاملة: <br />
                  لوز ، الشوفان ، بروكلي ، عدس ، الخبز ، بذور اليقطين ، الفول
                  السوداني ، البازلاء الخضراء ، افوكاد ، الفطر .
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            <h2>بعض الجداول التوضيحية :</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  :البدل الغذائي الموصى به من البروتين، على أساس العمر
                </h3>
              </div>
              <div className="info-section-body">
                <table>
                  <thead>
                    <tr>
                      <th>البروتين المطلوب (grams/day)</th>
                      <th>الفئة العمرية (Years)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data1.map((row) => (
                      <tr key={row.ageGroup}>
                        <td>{row.proteinNeeded}</td>
                        <td>{row.ageGroup}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  متطلبات البروتين الإضافية للحمل والرضاعة :
                </h3>
              </div>
              <div className="info-section-body">
                <table>
                  <thead>
                    <tr>
                      <th>الفئة</th>
                      <th>المدخول الآمن (grams/day)</th>
                      <th>متطلبات الطاقة الإضافية (kJ/day)</th>
                      <th>البروتين: نسبة الطاقة</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data2.map((row) => (
                      <tr key={row.category}>
                        <td>{row.category}</td>
                        <td>{row.safeIntake}</td>
                        <td>{row.additionalEnergyRequirement}</td>
                        <td>{row.proteinEnergyRatio}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كمية البروتين في الأطعمة الشائعة :
                </h3>
              </div>
              <div className="info-section-body">
                <table>
                  <thead>
                    <tr>
                      <th>الطعام</th>
                      <th>كمية البروتين</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data3.map((row) => (
                      <tr key={row.food}>
                        <td>{row.food}</td>
                        <td>{row.proteinAmount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ProteinCalculator;
